import { Controller } from "@hotwired/stimulus"

// Owns the money panel's two Turbo-Stream-replace papercuts (KT-834 review):
// - a secondary, formatted-currency echo of the amount field (the field is
//   dollars already; server-side validation, not this preview, is the guard
//   against a malformed amount -- see BudgetCommitmentForm)
// - restoring focus to the panel after a successful commitment submit, since
//   turbo_stream.replace swaps the whole panel (including the just-clicked
//   submit button), which otherwise resets focus to <body>
//
// Pure enhancement: the field and the form both work with JS off.
export default class extends Controller {
  static targets = ["amountField", "amountPreview"]
  static values = { justSubmitted: Boolean }

  connect() {
    // Only refocus when this panel was just re-rendered by the commitment
    // turbo-stream response (see create.turbo_stream.erb) -- an ordinary
    // page load/connect should never steal focus from the top of the page.
    if (this.justSubmittedValue) {
      this.element.focus()
    }

    this.previewAmount()
  }

  previewAmount() {
    if (!this.hasAmountFieldTarget || !this.hasAmountPreviewTarget) return

    const dollars = parseFloat(this.amountFieldTarget.value)

    if (Number.isNaN(dollars)) {
      this.amountPreviewTarget.textContent = ""
      return
    }

    const formatted = dollars.toLocaleString("en-US", { style: "currency", currency: "USD" })
    this.amountPreviewTarget.textContent = `= ${formatted}`
  }
}
